import { visualizacaoModoList } from '../../../../common/visualizacao-modo';

export class RepresentanteVisualizacao {
    modo: number;

    constructor() {
        this.modo = visualizacaoModoList.id;
    }
}
